import React from 'react'

export default function Download() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.3114 13.2207H1.68876C1.47227 13.2207 1.29907 13.3939 1.29907 13.6104C1.29907 13.8269 1.47227 14.0001 1.68876 14.0001H12.3114C12.5279 14.0001 12.7011 13.8269 12.7011 13.6104C12.7011 13.3939 12.5279 13.2207 12.3114 13.2207Z" fill="#03555E" />
      <path d="M6.72589 10.9315C6.79806 11.0037 6.89909 11.047 7.00012 11.047C7.10115 11.047 7.20218 11.0066 7.27435 10.9315L10.3774 7.82845C10.5304 7.67546 10.5304 7.4301 10.3774 7.27711C10.2244 7.12412 9.97909 7.12412 9.8261 7.27711L7.38981 9.7134V0.389691C7.38981 0.173196 7.21661 0 7.00012 0C6.78362 0 6.61043 0.173196 6.61043 0.389691V9.7134L4.17414 7.27711C4.02115 7.12412 3.77579 7.12412 3.6228 7.27711C3.46981 7.4301 3.46981 7.67546 3.6228 7.82845L6.72589 10.9315Z" fill="#03555E" />
    </svg>
  )
}
